// Libs
import dotenv from 'dotenv';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import Raven from 'raven-js';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import './utils/libs/indexedDB/idbHandler';
// Service Worker
import registerServiceWorker from './registerServiceWorker';
// Services
import { SentryService } from 'services';
// Routes
import RouteWithSubRoutes from './utils/routes/RouteWithSubRoutes';
// Store
import store from './store/configureStore';
// actions
import { doLogout } from 'screens/Login/actions';
// Context
import { RealtimeProvider } from 'context/RealtimeContext';
// Hooks
import useTheme from 'hooks/useTheme';
// Components
import { notification } from 'antd';
import { ModuleAccessControl, AppContainer } from 'components';
// Global Styles
import 'normalize.css';
import './index.css';
import './Badges.css';
import 'moment/locale/es';
import 'dayjs/locale/es';
import 'animate.css/animate.compat.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-virtualized/styles.css';
// Style
import { GlobalStyle } from 'themes';
// Load the existing application graph before the notification page's Login dependency.
import NotificationFile from './modules/Reports/NotificationFile';
import { NOTIFICATION_FILE_ROUTE } from './services/subscriptionFile';
import { watermarkedPhotoRoute, originalPhotoRoute } from './modules/Reports/WatermarkedPhoto';

dotenv.config();
SentryService.run();

notification.config({
	placement: 'bottomRight',
	bottom: 0,
});

const o = window.screen.orientation;
if (o && o.lock) {
	o.lock('portrait')
		.then(res => console.log(res))
		.catch(err => console.log(err));
}

const App = ({ theme, routes }) => {
	const { theme: _theme } = useTheme();
	const dispatch = useDispatch();

	useEffect(() => {
		if ('serviceWorker' in navigator) {
			const handleMessage = event => {
				if (event.data?.type !== 'LOGOUT') return;

				dispatch(doLogout());
			};
			navigator.serviceWorker.addEventListener('message', handleMessage);

			return () => {
				navigator.serviceWorker.removeEventListener('message', handleMessage);
			};
		}
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<GlobalStyle $newTheme={_theme} />
			<AppContainer>
				<Switch>
					<Route {...watermarkedPhotoRoute} />
					<Route {...originalPhotoRoute} />
					<Route exact path={NOTIFICATION_FILE_ROUTE} component={NotificationFile} />
					{routes.map((route, i) => (
						<RouteWithSubRoutes key={i} {...route} />
					))}
				</Switch>
			</AppContainer>
		</ThemeProvider>
	);
};

Raven.context(function () {
	ReactDOM.render(
		<Provider store={store}>
			<RealtimeProvider>
				<Router>
					<ModuleAccessControl
						rootApp={({ theme, routes }) => (
							<App theme={theme} routes={routes} />
						)}
					/>
				</Router>
			</RealtimeProvider>
		</Provider>,
		document.getElementById('root'),
	);

	// Register Official Service Worker
	registerServiceWorker();
});
